import React, { useState, useEffect, useRef } from 'react'
import { TabMenu } from 'primereact/tabmenu'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { isEnterpriseOrGsaUser } from './SLRUtils'
import './SlrBookingMenu.scss'

const SlrBookingMenu = () => {
	const history = useHistory()
	const location = useLocation()
	const { t } = useTranslation(['labels'])
	const [items, setItems] = useState([])
	const tabMenuRef = useRef(null)
	const [isEnterpriseOrGsa] = useState(() => isEnterpriseOrGsaUser())

	useEffect(() => {
		if (!isEnterpriseOrGsa) {
			return
		}

		const activeIndex = location.pathname.startsWith('/slr-bookings/input') || location.pathname.startsWith('/slr-bookings/modify')
			? 1
			: 0

		const baseItems = [
			{
				label: t('BOOKING.MANAGE_SLR'),
				command: () => history.push('/slr-bookings'),
				className: 'tab-manage-slr',
			},
			{
				label: t('BOOKING.NEW_SLR'),
				command: () => history.push('/slr-bookings/input'),
				className: 'tab-new-slr',
			},
		]

		const updatedItems = baseItems.map((item, index) => ({
			...item,
			className:
				index === activeIndex
					? `${item.className} p-highlight`
					: item.className,
		}))

		setItems(updatedItems)

		// Manually update p-highlight class on DOM
		setTimeout(() => {
			const tabMenu = tabMenuRef.current
			if (tabMenu) {
				const tabs = tabMenu.querySelectorAll('.p-tabmenuitem')
				tabs.forEach((tab, index) => {
					if (index === activeIndex) {
						tab.classList.add('p-highlight')
					} else {
						tab.classList.remove('p-highlight')
					}
				})
			}
		}, 0)
	}, [location.pathname, t, history])

	const onTabChange = (e) => {
		e.value?.command?.()
	}

	if (!isEnterpriseOrGsa) {
		return null
	}

	return (
		<div className='slr-booking-menu' ref={tabMenuRef}>
			<TabMenu model={items} onTabChange={onTabChange} className='tab-booking'/>
		</div>
	)
}

export default SlrBookingMenu
